<div class="row">

    <mat-tab-group mat-align-tabs="start" #tabGroup (selectedIndexChange)="selectedChangeValue($event)"
        [(selectedIndex)]="indiceTab">
        <mat-tab label="PRIME">
            <div *ngIf="indiceTab == 0" style="overflow-x: hidden;padding: 10px;">
                <app-prime-famille [matricule_assure]="matricule_assure"></app-prime-famille>
            </div>
        </mat-tab>

        <mat-tab label="DEPENSES">
            <div *ngIf="indiceTab == 1" style="overflow-x: hidden">
                
                <app-depense-famille [matricule_assure]="matricule_assure"></app-depense-famille>
            </div>
        </mat-tab>
        <mat-tab label="RESEAU DE SOIN">
            <div *ngIf="indiceTab == 2" style="overflow-x: hidden">
                
                <app-reseau-de-soin-famille [matricule_assure]="matricule_assure"></app-reseau-de-soin-famille>
            </div>
        </mat-tab>

                <mat-tab label="DERNIERES PRESCRIPTIONS">
            <div *ngIf="indiceTab == 3" style="overflow-x: hidden">
                
                <app-famille-derniere-prescription [matricule_assure]="matricule_assure"></app-famille-derniere-prescription>
            </div>
        </mat-tab>
        <mat-tab label="DERNIERES PRESTATIONS">
            <div *ngIf="indiceTab == 4" style="overflow-x: hidden">
                
                <app-famille-derniere-prestation [matricule_assure]="matricule_assure"></app-famille-derniere-prestation>
            </div>
        </mat-tab>

        <!-- <mat-tab label="GED">
            <div *ngIf="indiceTab == 4" style="overflow-x: hidden">
                
                <app-ged-famille [matricule_assure]="matricule_assure"></app-ged-famille>
            </div>
        </mat-tab> -->

    </mat-tab-group>

</div>